import React, { useEffect, useState } from 'react'

import Modal from 'react-bootstrap/Modal';
import Cookies from 'js-cookie';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faComment } from '@fortawesome/free-solid-svg-icons';

import logo from "../../../assets/images/adm_logo.png"
import NotificationService from '../../../services/notification.service';

import { notificationIcon, chatIcon2, fileIcon } from '../../../utils/icons';
// import io from 'socket.io-client';
import LoginAuth from '../../../services/auth.service';
import FilesService from '../../../services/files.service';
import { setLoading } from '../../../feature/loading.slice';
import { setMessage } from '../../../feature/message.slice';
import { useDispatch } from 'react-redux';
import PreviewFileModal from '../Filemanager_PreviewFileModal';
import { getTotpStatus } from '../../../services/profile.service';


// Connect to the socket.io server
// const socket = io(process.env.REACT_APP_API_URL);
const Header = () => {

    const [notificationshow, notiFicationsetShow] = useState(false);
    const [notifications, setnotifications] = useState([])
    // console.log("notifications",notifications)
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [fileBlob, setFileBlob] = useState(null);
    const [fileType, setFileType] = useState(null);

    const [userId, setuserId] = useState("")
    const [unreadCount, setUnreadCount] = useState("");
    // console.log( "Count",unreadCount)
    const [notificationType, setnotificationType] = useState("")
    // console.log(notificationType)

    const notificationhandleClose = () => notiFicationsetShow(false);
    const updateUnread = async () => {
        try {
            const updateunread = await NotificationService.updateUnread()
            console.log(updateunread)
        } catch (err) {
            console.log(err)
        }
    }
    const notificationhandleShow = () => {
        notiFicationsetShow(true)
        updateUnread()
    };


    const [showPopup, setShowPopup] = useState(false);
    const setShowPopupclose = () => setShowPopup(false);
    const setShowPopupshow = () => setShowPopup(true);
    const [userName, setuserName] = useState("")
    const [surname, setsurname] = useState("")
    const [fetchNotificationBysocket, setfetchNotificationBysocket,] = useState(false)
    // console.log(fetchNotificationBysocket)
    useEffect(() => {
        const userName = localStorage.getItem('userName');
        const surname = localStorage.getItem('middleName');

        setuserName(userName)
        setsurname(surname)
    }, [])

    // "Set up 2FA" badge: only while client 2FA is switched on and this client
    // has nothing set up. Once set up there is nothing to manage here - only
    // staff can turn it off, from Teams - so the badge simply goes away.
    const [twoFactorDue, setTwoFactorDue] = useState(null); // { deadline } or null
    useEffect(() => {
        getTotpStatus()
            .then((d) => {
                if (d.two_factor_on && (d.enrolled || []).length === 0) {
                    setTwoFactorDue({ deadline: d.deadline || null });
                }
            })
            .catch(() => {});
    }, [])

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

    const navigate = useNavigate();
    const logout = async () => {
        await LoginAuth.logout();
      navigate('/login', { replace: true });
    }

    const profile = async () => {
        
        navigate("/profile")
    }


    const fetchNotification = async () => {
  
        try {
            const getNotification = await NotificationService.getNotifications()
            const models = notifications.map(notification => notification.model);
            setnotificationType(models.join(", "));
            setUnreadCount(getNotification.notifications.filter(notification => notification.unread == null).length);

            console.log(getNotification)
            setnotifications(getNotification.notifications)

        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchNotification()

    }, [])



    // useEffect(() => {
    //     const socket = io(process.env.REACT_APP_API_URL);
    
      
    //     socket.on('newNotification', (data) => {
       
    //       fetchNotification();
    //     });
    
       
    //     return () => {
    //       socket.disconnect();
    //     };
    //   }, []);




    // useEffect(() => {
    //     if (fetchNotificationBysocket == true) {

    //         fetchNotification()
    //         setfetchNotificationBysocket(false)
    //     }
    // }, [fetchNotificationBysocket])

    // socket.on('connects', () => {
    //     setfetchNotificationBysocket(true)
    //     console.log('Connected to socket.io server');
    // });

    // socket.on('notificationUpdate', () => {
    //     setfetchNotificationBysocket(true)
    //     console.log('Notification update received:');
    //     // Handle the notification update
    // });

    // socket.on('disconnects', () => {
    //     setfetchNotificationBysocket(false)
    //     // console.log('Disconnected from socket.io server');
    // });

    const getNotificationTitle = (model) => {
        switch (model) {
            case "ChatThread":
                return "MESSAGE";
            case "Task":
                return "DOCUMENT";
            default:
                return "UNKNOWN";
        }
    };


    const getTimeDifference = (lastMessageTime) => {
        const now = new Date();
        const lastMessageDate = new Date(lastMessageTime);
        const diffInMs = now - lastMessageDate;
        const diffInMinutes = Math.floor(diffInMs / 60000);

        if (diffInMinutes < 1) return 'Just now';
        if (diffInMinutes < 60) return `${diffInMinutes} mins ago`;

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hours ago`;

        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} days ago`;
    };



    // const handleNotificationDetails = async (notifications) => {
    //     // console.log(notifications)
    //     const model = notifications.model
    //     const modelId = notifications.model_id

    //     notiFicationsetShow(false)
    //     if (model == "ChatThread") {
    //         const queryParams = new URLSearchParams({
    //             threadId: modelId,
    //        });
    //         navigate(`/chats?${queryParams.toString()}`, { state: { NotificationThreadId: modelId } })
    //     } 
    //     else if (model == "ClientFile") {
    //          navigate('/documents')
    //     } 
        
    //     else {
    //         navigate("/")
    //     }
    // }


    const handleClose = (e) => {
        if(e) e.stopPropagation(); // Prevent bubbling if needed
        setShow(false);
      };


    const handleNotificationDetails = async (e,notifications) => {

        const model = notifications.model
         const modelId = notifications.model_id
        if(e) e.stopPropagation(); // Prevent event bubbling
        // If modal is already open, do nothing
        if (show) return;
    
        // Determine which model to use
        if (model === "ChatThread") {
          const queryParams = new URLSearchParams({
            threadId: modelId,
          });
          navigate(`/chats?${queryParams.toString()}`, { state: { NotificationThreadId: modelId } })
        } else if (model === "ClientFile") {
          try {
            dispatch(setLoading(true));
            dispatch(setMessage("Please wait.."));
            const res = await FilesService.filePreview(modelId);
            if (res) {
              const blob = res.data;
              const blobUrl = URL.createObjectURL(blob);
              setFileBlob(blobUrl);
              setFileType(res.headers["content-type"]);
              setShow(true);
              dispatch(setLoading(false));
            } else {
              console.error("Failed to fetch file");
            }
          } catch (err) {
            setFileBlob(null);
            setShow(true);
            dispatch(setLoading(false));
            console.log(err);
          }
        } else {
          navigate("/");
        }
      };

    const handleUpdateNotification=(event)=>{
        event.stopPropagation();
        // alert('hello')
        setUnreadCount("")
        updateUnread()
      }


    return (
        <>
            <div className="header">
                <div className="container-fluid">
                    {twoFactorDue && (
                        <button
                            type="button"
                            className="btn btn-sm btn-warning d-flex align-items-center gap-1 me-3 rounded-pill px-3"
                            style={{ fontSize: '0.78rem', fontWeight: 600, lineHeight: 1.2 }}
                            title={twoFactorDue.deadline
                                ? `Two-factor authentication becomes required after ${new Date(twoFactorDue.deadline + 'T00:00:00').toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })}`
                                : 'Add a second step at login'}
                            onClick={() => navigate('/setup-2fa')}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6z" />
                                <path d="M12 8v4" /><path d="M12 16h.01" />
                            </svg>
                            Set up 2FA
                        </button>
                    )}
                    <div className="notifications dropdown" onClick={handleUpdateNotification}>
                    

                        <button className="btn btn-link bell dropdown-toggle" id='notificationDropdown' type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={notificationIcon} alt="Notifications"  />
                            {unreadCount > 0 && <span className="notifications__counter">{unreadCount > 10 ? '10+' : unreadCount}</span>}
                        </button>

                        <ul className="dropdown-menu notifications-dropdown" aria-labelledby="notificationDropdown">
                            
                                <div className="card-body">
                                    <ul className="list-group list-group-flush">
                                        {notifications && notifications.map((notification, index) => (
                                            <li
                                                key={index}
                                                className="list-group-item"
                                                onClick={(e) => handleNotificationDetails(e,notification)}
                                            >
                                                <div className="notification-title">
                                                    {notification.title}
                                                </div>
                                                <div className="notification-content">
                                                    <div className='icon'>
                                                    {notification.model === "File" ? (
                                                        <img src={fileIcon}  />
                                                    ) : notification.model === "ChatThread" ? (
                                                        <img src={chatIcon2} />
                                                    ) : (
                                                        ""
                                                    )}
                                                    </div>
                                                    <div className="notification-message">
                                                    <div
          dangerouslySetInnerHTML={{
            __html: notification.message.length > 50
              ? `${notification.message.substring(0, 50)}...`
              : notification.message,
          }}
        />
                                                    </div>
                                                </div>
                                                <span className="notification-time">
                                                    By {notification.senderName} |{" "}
                                                    {notification.timeAgo}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            
                        </ul>
                    </div>

                    <div className="myaccount-dropdown dropdown">
                    
                        <button className='btn btn-link user dropdown-toggle' id="userDropdown" type='button' data-bs-toggle='dropdown' data-bs-auto-close="true" aria-expanded='false'>

                        {`${userName} ${surname!=null?surname:""}`}

                       

                            </button>
                        <ul className="dropdown-menu" aria-labelledby="userDropdown">
                            
                            {/* Buttons, not href-less links: those get no pointer cursor. */}
                            <li><button type="button" className="dropdown-item" onClick={profile}>Profile</button></li>
                            <li><button type="button" className="dropdown-item" onClick={logout}>Logout</button></li>
                        </ul>
                    </div>
                </div>
                {show && (
        <PreviewFileModal
          show={show}
          handleClose={handleClose}
          fileUrl={fileBlob}
          fileType={fileType}
        />
      )}
            </div>
        </>



    )
}

export default Header